import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

// Also read by the consent-default script in public/index.html — keep the key and values in sync.
const CONSENT_KEY = 'cookieConsent';

// Outside opt-in regions GA starts with analytics_storage granted, so _ga cookies may already
// exist by the time a visitor picks "Necessary Only". Denying consent stops new writes but does
// not remove existing cookies, so expire them here.
const removeAnalyticsCookies = () => {
  const host = window.location.hostname;
  const domains = ['', host, `.${host}`, `.${host.replace(/^www\./, '')}`];
  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0].trim();
    if (name === '_ga' || name.startsWith('_ga_')) {
      domains.forEach((domain) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain ? `; domain=${domain}` : ''}`;
      });
    }
  });
};

function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    } else {
      // Apply stored consent preference
      applyConsent(consent);
    }
  }, []);

  const applyConsent = (consentType) => {
    if (typeof window.gtag === 'function') {
      if (consentType === 'all') {
        // Grant analytics consent
        window.gtag('consent', 'update', {
          analytics_storage: 'granted'
        });
      } else {
        // Deny analytics consent
        window.gtag('consent', 'update', {
          analytics_storage: 'denied'
        });
      }
    }
    if (consentType !== 'all') {
      removeAnalyticsCookies();
    }
  };

  const handleAcceptAll = () => {
    localStorage.setItem(CONSENT_KEY, 'all');
    applyConsent('all');
    setVisible(false);
  };

  const handleNecessaryOnly = () => {
    localStorage.setItem(CONSENT_KEY, 'necessary');
    applyConsent('necessary');
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <p>
          We use cookies to improve your experience and analyze site usage.
          Read our <Link to="/privacy">Privacy Policy</Link> for more information.
        </p>
        <div className="cookie-consent-buttons">
          <button
            className="btn btn-secondary"
            onClick={handleNecessaryOnly}
          >
            Necessary Only
          </button>
          <button
            className="btn btn-primary"
            onClick={handleAcceptAll}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
